<template>
  <div id="registration" class="registration">
    <div
      v-if="
        missingRegistrationData.length &&
          (isPreparingData || registrationDataFailed)
      "
      class="preparing-data-banner"
      :class="{ 'preparing-data-banner--failed': registrationDataFailed }"
    >
      <template v-if="isPreparingData">
        <span class="preparing-data-spinner"></span>
        Setting up registration data…
      </template>
      <template v-else>
        Couldn't load {{ missingRegistrationData.join(", ") }}.
        <button class="preparing-data-retry" @click="loadRegistrationData">
          Retry
        </button>
      </template>
    </div>
    <div class="header" style="padding: 0 2rem;">
      <div
        class="patient-registration flex align-center space-between"
        style="padding-top: 1rem !important;"
      >
        <Heading heading="Registration Form" class="mb-base" />
        <div class="flex">
          <Select
            class="mr-2"
            styles="expenses-select"
            :placeholder="branchPlaceHolder"
            :input="handleBranchChange"
            :options="brachData"
          />
          <SearchSuggestions
            @input="handlePatientSearch"
            :suggestions="suggestions"
            icon="mdi-magnify"
            class="mb-base"
            placeholder="Search by MR, Mobile No"
            :isLoading="isLoading"
            :handleReset="resetSearch"
            :handleSearch="handleSearchPatient"
            @suggestion="suggestion"
            reset
          />
          <span
            style="margin-top: 0.6rem; margin-left: 10px;"
            title="Reset form"
            ><i
              style="font-size: 1.2rem; cursor: pointer;"
              class="mdi mdi-reload"
              @click="handleFromReset"
            ></i
          ></span>

          <span
            style="margin-top: 0.6rem; margin-left: 10px;"
            title="Printer Settings"
            ><i
              style="font-size: 1.2rem; cursor: pointer;"
              class="mdi mdi-cog"
              @click="$modal.show('printerSettings')"
            ></i
          ></span>
        </div>
      </div>
      <div class="patient-information mb-5">
        <div class="heading flex align-center space-between">
          <h2>Patient Information</h2>
          <div class="date">
            <p>
              {{ patientDetails.mr_no ? patientDetails.mr_no : currentDate }}
            </p>
          </div>
        </div>
        <validation-observer ref="observer">
          <form @submit.prevent>
            <div class="row mb-base">
              <validation-provider
                class="col-4"
                rules="required"
                v-slot="{ errors }"
              >
                <Input
                  class="mb-base"
                  label="Full Name"
                  type="text"
                  :error="errors[0]"
                  v-model="patientDetails.name"
                />
              </validation-provider>
              <validation-provider
                class="col-4"
                rules="required"
                v-slot="{ errors }"
              >
                <Input
                  class="mb-base"
                  label="Father/Husband Name"
                  type="text"
                  :error="errors[0]"
                  v-model="patientDetails.fatherOrHusbandName"
                />
              </validation-provider>
              <validation-provider
                class="col-4"
                rules="required"
                v-slot="{ errors }"
              >
                <div class="mb-base">
                  <Input
                    type="text"
                    label="Age"
                    :error="errors[0]"
                    v-model="patientDetails.age"
                  />
                  <small class="text-gray-500" style="font-size: 12px;">
                    Enter age (e.g., 25, 1Yrs, 2Months, 1Day, 3Days OR
                    1Yr-2Months)
                  </small>
                </div>
              </validation-provider>
              <validation-provider
                class="col-4"
                rules="required"
                v-slot="{ errors }"
              >
                <Input
                  class="mb-base"
                  label="Address"
                  type="text"
                  :error="errors[0]"
                  v-model="patientDetails.address"
                />
              </validation-provider>
              <validation-provider
                class="col-4"
                rules="phoneNumber"
                v-slot="{ errors }"
              >
                <Input
                  class="mb-base"
                  label="Contact Number"
                  type="number"
                  :error="errors[0]"
                  v-model="patientDetails.contactNumber"
                />
              </validation-provider>
              <validation-provider
                class="col-4"
                rules="required"
                v-slot="{ errors }"
              >
                <Radio
                  class="mb-base"
                  outerLabel="Gender"
                  labelFor="Gender"
                  type="radio"
                  name="custom"
                  :error="errors[0]"
                  v-model="userGender"
                  :options="gender"
                />
              </validation-provider>
              <div class="col-4 mb-base">
                <Select
                  class="reffered-to"
                  label="Referred By"
                  styles="role-select"
                  :value="referredBy.name"
                  :input="handlerefferedBy"
                  :options="refferedByDoctors"
                  :loading="isLoadingRefferedBy"
                />
                <div
                  class="flex align-center cursor-pointer add-doctor"
                  @click="handleAddDoctor"
                >
                  <img src="@/assets/plus-icon-small.png" alt="icon" />
                  <span>Add new doctor</span>
                </div>
              </div>
              <Select
                class="mb-base reffered-to col-4"
                label="Referred to"
                styles="role-select"
                :value="refferedTo.name"
                :input="handleRefferedTo"
                :options="refferedDoctor"
                :loading="isLoadingRefferedTo"
              />
              <TextArea
                label="Comment"
                style="width: 20rem; margin-right: -20rem; margin-top: -0.4rem;"
                styles="  reffered-to mb-base mr-2 col-4"
                name="comment"
                placeholder="Write detail comment here"
                v-model="patientDetails.note"
              />
            </div>
          </form>
        </validation-observer>
        <div id="print-invoice">
          <PrintTable
            v-for="i in [
              ...(isOther === 'Laboratory' || isDoubleInvoicePrint
                ? [1, 2]
                : [1])
            ]"
            :key="i"
            :refferedTo="refferedTo.name"
            :refferedBy="referredBy.name"
            :searchResult="searchResult"
            :registerPatient="invoicePatient"
            :rows="serviceRowsPrint"
            :total="sumValue"
            :selectedPanel="selectedDiscountType"
            :discount="discountAmount"
            :invoiceNo="invoiceNo"
            :isOther="isOther"
            :invoiceStatus="invoiceStatus"
            :comment="patientDetails.note"
            :patientGender="userGender"
            class="mb-5"
          />
        </div>
      </div>
      <div id="externalInvoice">
        <ExternalInvoice
          :invoiceNo="invoiceNo"
          :patient="invoicePatient"
          :searchResult="searchResult"
          :refferedTo="refferedTo"
          :referredBy="referredBy.name"
          :rows="serviceRowsPrint"
          :charges="sumValue"
          :selectedDiscountType="selectedDiscountType"
          :isOther="isOther"
          :discount="discountAmount"
          :branch_logo="branchLogoUrl"
          :org_logo="bussinessLogoUrl"
          :showReceiptCopies="!a4PrescriptionOnly"
          :patientGender="userGender"
        />
      </div>
      <transition name="fade">
        <div class="charges-table mb-base">
          <div>
            <charges-table
              :cols="serviceColumns"
              :rows="serviceRows"
              :addItems="handleInvoiceItems"
            >
              <template slot="service" slot-scope="{ services }">
                <div class="services">
                  <Select
                    styles="invoice-select"
                    :value="services.name"
                    ref="service_selector"
                    :input="val => handleServiceSelect(val, services)"
                    :options="servicesList"
                    :clearable="false"
                    placeholder="Select a service "
                  />
                </div>
              </template>
              <template slot="quantity" slot-scope="{ quantity }">
                <div class="discount-price">
                  <Input
                    @input="val => handleQuantity(val, quantity.id)"
                    type="number"
                    placeholder="Quantity"
                    v-model="quantity.quantity"
                  />
                </div>
              </template>
              <template slot="discount" slot-scope="{ discount }">
                <div class="discount-price">
                  <Input
                    @input="val => handleDiscount(val, discount.id)"
                    type="number"
                    placeholder="Discount"
                    v-model="discount.discountValue"
                  />
                </div>
              </template>
              <template
                slot="discountPercentage"
                slot-scope="{ discountPercentage }"
              >
                <div class="discount-price">
                  <Input
                    @input="
                      val =>
                        handleDiscountPercentAge(val, discountPercentage.id)
                    "
                    type="number"
                    style="width: 60%;"
                    placeholder="Discount %"
                    v-model="discountPercentage.discountPercentageValue"
                  />
                </div>
              </template>
              <template slot="action" slot-scope="{ actions }">
                <div class="actions">
                  <span
                    @click="handleDeleteItem(actions)"
                    class="cursor mr-2 mdi mdi-24px mdi-delete"
                  ></span>
                </div>
              </template>
            </charges-table>
            <div class="add-charges flex align-center justify-center mt-5 mb-5">
              <button class="flex align-center" @click="handleInvoiceItems">
                <img src="@/assets/plus-icon.png" alt="plus" />
                Add New Invoice Item
              </button>
            </div>
          </div>
          <div class="total-bill mt-4 mb-base">
            <div class="total flex justify-end mb-1">
              <div class="flex">
                <h2 class="mr-1">
                  Grand Total <span style="font-size: medium;">(PKR)</span>
                </h2>
                <h2>{{ grandTotal }}</h2>
              </div>
              <div class="flex">
                <h2 class="mr-1">
                  Total Discount
                  <span style="font-size: medium;">(PKR)</span>
                </h2>
                <h2>{{ discountAmount }}</h2>
              </div>
              <div class="flex">
                <h2 class="mr-1">
                  Net Total <span style="font-size: medium;">(PKR)</span>
                </h2>
                <h2>{{ sumValue }}</h2>
              </div>
            </div>
            <div class="discount flex align-center justify-end">
              <div class="flex discount-amount">
                <Checkbox
                  class="mb-1"
                  type="checkbox"
                  name="isInsurance"
                  id="isInsurance"
                  v-model="isInsurance"
                  label="Is insurance"
                />
                <span v-if="isInsurance" :class="{ userClass: discountToggle }">
                  <Select
                    styles="invoice-select"
                    label="Company Name"
                    class="mr-2 mb-2"
                    :options="discountType"
                    :input="handleDiscountTpye"
                    placeholder="Select Company"
                  />
                </span>
                <div>
                  <Radio
                    class="mb-1"
                    outerLabel="Invoice Type"
                    type="radio"
                    className="flex-3"
                    v-model="isOther"
                    :options="invoiceType"
                    styles="invoice-type"
                  />
                </div>
              </div>
            </div>
            <div class="bill-actions flex align-center justify-end">
              <Button
                className="button--transparent mb-base mr-1"
                title="Cancel"
                :onClick="resetForm"
              ></Button>
              <Button
                className="
                      button--primary mb-base
                    "
                :disabled="isRegistrationsLoading"
                :class="{ 'pointer-events-none': isRegistrationsLoading }"
                title="Save"
                :loader="isRegistrationsLoading"
                :onClick="handleSave"
              ></Button>
            </div>
          </div>
        </div>
      </transition>
      <!-- </tab>
      </tabs> -->
    </div>
    <DoctorAdd />
    <AppModal
      name="printConfirmation"
      title="Print Selection"
      height="auto"
      width="420"
      @closed="onPrintModalClosed"
    >
      <template v-slot:content>
        <div class="print-modal-content">
          <!-- Printer Connection Status -->
          <div
            :class="[
              'printer-status-bar',
              printerIsConnected ? 'connected' : 'disconnected'
            ]"
          >
            <span
              :class="[
                'mdi mdi-20px',
                printerIsConnected ? 'mdi-printer-check' : 'mdi-printer-off'
              ]"
            ></span>
            <div class="printer-info">
              <span class="printer-label">{{
                printerIsConnected ? "Ready" : "Not Connected"
              }}</span>
              <span class="printer-name">{{
                printerIsConnected ? printerName : "Connect thermal printer"
              }}</span>
            </div>
            <Button
              v-if="!printerIsConnected"
              title="Connect"
              className="button--primary button--xs"
              :onClick="connectPrinter"
            />
          </div>

          <div class="print-options">
            <p class="options-title">Select copies to print:</p>

            <!-- Patient Copy -->
            <div
              class="print-option"
              :class="{ selected: printPatientCopy }"
              @click="printPatientCopy = !printPatientCopy"
            >
              <div class="option-icon patient">
                <span class="mdi mdi-account"></span>
              </div>
              <div class="option-text">
                <span class="option-label">Customer Copy</span>
                <span class="option-desc">Receipt for patient</span>
              </div>
              <div class="option-check">
                <span
                  v-if="printPatientCopy"
                  class="mdi mdi-check-circle"
                ></span>
                <span
                  v-else
                  class="mdi mdi-checkbox-blank-circle-outline"
                ></span>
              </div>
            </div>

            <!-- Official Copy -->
            <div
              class="print-option"
              :class="{ selected: printOfficialCopy }"
              @click="printOfficialCopy = !printOfficialCopy"
            >
              <div class="option-icon official">
                <span class="mdi mdi-file-document"></span>
              </div>
              <div class="option-text">
                <span class="option-label">{{
                  isOther === "Laboratory" ? "Lab Copy" : "Doctor Copy"
                }}</span>
                <span class="option-desc">Official records</span>
              </div>
              <div class="option-check">
                <span
                  v-if="printOfficialCopy"
                  class="mdi mdi-check-circle"
                ></span>
                <span
                  v-else
                  class="mdi mdi-checkbox-blank-circle-outline"
                ></span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="print-modal-footer">
          <a href="#" @click.prevent="switchToA4" class="a4-link">
            <span class="mdi mdi-file-outline"></span> Use A4 Print
          </a>
          <div class="footer-buttons">
            <button
              class="btn-cancel"
              @click="$modal.hide('printConfirmation')"
            >
              Cancel
            </button>
            <button
              class="btn-print"
              :disabled="
                !printerIsConnected || (!printPatientCopy && !printOfficialCopy)
              "
              @click="executePrint"
            >
              <span class="mdi mdi-printer"></span> Print
            </button>
          </div>
        </div>
      </template>
    </AppModal>

    <AppModal name="a4AfterThermal" title="A4 Print" height="auto" width="420">
      <template v-slot:content>
        <div class="print-modal-content">
          <p class="options-title">
            Thermal print done. Do you want to print the Doctor prescription on
            A4 as well?
          </p>
        </div>
      </template>
      <template v-slot:footer>
        <div class="print-modal-footer">
          <div
            class="footer-buttons"
            style="justify-content: flex-end; width: 100%;"
          >
            <button class="btn-cancel" @click="skipA4AfterThermal">
              Skip
            </button>
            <button class="btn-print" @click="printA4AfterThermal">
              <span class="mdi mdi-file-outline"></span> Print A4
            </button>
          </div>
        </div>
      </template>
    </AppModal>

    <AppModal
      name="printerSettings"
      title="Printer Settings"
      height="auto"
      width="400"
    >
      <template v-slot:content>
        <div class="printer-settings-modal-body">
          <p class="section-title">Select Default Printer</p>
          <div class="printer-grid">
            <!-- A4 Card -->
            <div
              class="sel-card"
              :class="{ active: printerType === 'A4' }"
              @click="
                printerType = 'A4';
                savePrinterType();
              "
            >
              <div class="sel-card-icon">
                <span class="mdi mdi-file-document-outline"></span>
              </div>
              <div class="sel-card-content">
                <h6>A4 Printer</h6>
                <p>Standard documents</p>
              </div>
              <div class="sel-card-radio">
                <div class="radio-circle"></div>
              </div>
            </div>

            <!-- Thermal Card -->
            <div
              class="sel-card"
              :class="{ active: printerType === 'Thermal' }"
              @click="
                printerType = 'Thermal';
                savePrinterType();
              "
            >
              <div class="sel-card-icon">
                <span class="mdi mdi-printer-pos"></span>
              </div>
              <div class="sel-card-content">
                <h6>Thermal Printer</h6>
                <p>Receipt printing</p>
              </div>
              <div class="sel-card-radio">
                <div class="radio-circle"></div>
              </div>
            </div>
          </div>

          <!-- Thermal Status Block -->
          <transition name="fade">
            <div v-if="printerType === 'Thermal'" class="printer-status-block">
              <div
                class="status-badge"
                :class="
                  printerIsConnected ? 'bg-success-light' : 'bg-warning-light'
                "
              >
                <span
                  :class="[
                    'mdi mr-1',
                    printerIsConnected ? 'mdi-check-circle' : 'mdi-alert-circle'
                  ]"
                ></span>
                {{ printerIsConnected ? "Connected" : "Action Required" }}
              </div>

              <div class="status-detail mt-3">
                <div
                  class="status-icon-box"
                  :class="{ inactive: !printerIsConnected }"
                >
                  <span
                    :class="[
                      'mdi',
                      printerIsConnected ? 'mdi-usb-port' : 'mdi-usb-port-off'
                    ]"
                  ></span>
                </div>
                <div class="status-text-box">
                  <span class="device-name">{{
                    printerIsConnected ? printerName : "Printer Not Found"
                  }}</span>
                  <span class="device-hint">{{
                    printerIsConnected
                      ? "Ready for printing"
                      : "Connect via USB"
                  }}</span>
                </div>
                <Button
                  :title="printerIsConnected ? 'Configure' : 'Connect'"
                  :className="
                    printerIsConnected
                      ? 'button--transparent no-vertical-padding'
                      : 'button--primary no-vertical-padding'
                  "
                  style="min-width: 90px; height: 32px;"
                  :onClick="connectPrinter"
                />
              </div>
            </div>
          </transition>
        </div>
      </template>
      <template v-slot:footer>
        <div class="modal-footer-actions">
          <Button
            title="Close"
            className="button--primary"
            :onClick="() => $modal.hide('printerSettings')"
          />
        </div>
      </template>
    </AppModal>
  </div>
</template>

<script>
import Heading from "@/components/Heading";
import Input from "@/components/Input";
import Checkbox from "@/components/Checkbox";
import ChargesTable from "@/components/ChargesTable";
import PrintTable from "@/components/PrintTable";
// import PatientReports from "./reports";
// import Details from "./Details.vue";
import TextArea from "@/components/TextArea.vue";
import Select from "@/components/Select";
import Button from "@/components/Button";
import Radio from "@/components/Radio";
// import TodayList from "./list";
// import FinanceReport from "./FinanceReport";
// import PatientStatusReport from "./PatientStatusReport.vue";
import ExternalInvoice from "@/components/externalInvoice";
import Modal from "@/components/Modal";
import DoctorAdd from "./addDoctor.vue";
import SearchSuggestions from "../../../components/SearchSuggestions.vue";
import moment from "moment";
// import { Tabs, Tab } from "vue-tabs-component";
import { mapActions, mapGetters } from "vuex";
import { getGender, formatGender, formatAgeYear } from "@/utils/helpers";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import {
  sum,
  handleRows
  // handleDiscountedPrice,
} from "@/utils/helpers";
import printDiv from "@/utils/print";
import {
  formatedDate,
  handleQuantityNumber,
  getBranchLogo,
  calculateDiscountPercent
} from "../../../utils/helpers";
import { permissionsMiddleWare } from "../../../utils/permissionsMiddleWare";
import ThermalPrintService from "@/utils/ThermalPrintService";
import { recordA4Prescription } from "@/utils/printTestHooks";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    // PatientStatusReport,
    SearchSuggestions,
    // PatientReports,
    TextArea,
    ExternalInvoice,
    // FinanceReport,
    DoctorAdd,
    // Details,
    Checkbox,
    PrintTable,
    // TodayList,
    ChargesTable,
    Heading,
    Button,
    Radio,
    Select,
    Input,
    AppModal: Modal
    // Tabs,
    // Tab,
  },
  data() {
    return {
      bussinessLogoUrl: "",
      branchLogoUrl: "",
      isAdmin: null,
      isLoading: false,
      isLoadingRefferedBy: false,
      isLoadingRefferedTo: false,
      isRegistrationsLoading: false,
      patientDetails: {},
      searchResult: {},
      userGender: "",
      lookupId: "",
      company: "",
      refferedTo: {},
      referredBy: {},
      isInsurance: false,
      userClass: "userClass",
      discountToggle: true,
      registrationId: "",
      invoiceNo: null,
      isOther: "Radiology",
      isDoubleInvoicePrint: false,
      printPatientCopy: true,
      printOfficialCopy: false,
      printDetailsData: null,
      printInProgress: false,
      pendingA4AfterThermal: null,
      a4PrescriptionOnly: false,
      a4PrintPatient: null,
      suggestions: [],
      printerIsConnected: false,
      printerName: "",
      invoiceStatus: 1,
      resetSearch: false,
      gender: [
        { id: "male", for: "male", label: "Male" },
        { id: "female", for: "female", label: "Female" }
      ],
      invoiceType: [
        { id: "fhh", for: "fhh", label: "Doctor" },
        { id: "fhhl", for: "fhhl", label: "Laboratory" },
        { id: "medirad", for: "medirad", label: "Radiology" }
      ],
      printerOptions: [
        { id: "a4", for: "a4", label: "A4" },
        { id: "thermal", for: "thermal", label: "Thermal" }
      ],
      serviceColumns: [
        { column: "serial", label: "#", width: "60", isVisible: true },
        {
          column: "service",
          label: "Service Availed",
          width: "400",
          isVisible: true
        },
        { column: "price", label: "Price", isVisible: true },
        {
          column: "quantity",
          label: "Quantity",
          width: "200",
          isVisible: true
        },
        {
          column: "discount",
          label: "Discount ",
          width: "150",
          isVisible: true
        },
        {
          column: "discountPercentage",
          label: "Discount %",
          width: "200",
          isVisible: true
        },

        { column: "subtotal", label: "Sub Total", isVisible: true },
        { column: "action", label: "Actions", isVisible: true }
      ],
      serviceRows: [
        {
          id: 1,
          service: "",
          price: 0,
          subtotal: 0,
          discountValue: 0,
          quantity: 1,
          lookupId: null,
          discountPercentageValue: 0,
          serviceId: null,
          branchId: null
        }
      ],
      currentId: null,
      organizationDiscount: null,
      brachData: [],
      sidebarToggle: false,
      selectedBranchId: null,
      grandTotal: 0,
      handleSearchPatientValue: "",
      toggle: false,
      discountTypeId: null,
      selectedDiscountType: "",
      printerType: localStorage.getItem("printer_type") || "Thermal",
      isPreparingData: false,
      registrationDataFailed: false
    };
  },
  methods: {
    ...mapActions({
      addPatient: "receptionist/addPatient",
      getInvoiceNumber: "receptionist/getInvoiceNumber",
      addHistory: "receptionist/addHistory",
      searchPatient: "receptionist/searchPatient",
      listPatients: "receptionist/listPatients",
      updateTokenStatus: "receptionist/updateTokenStatus",
      listDoctors: "receptionist/listDoctors",
      updateDetails: "receptionist/updateDetails",
      listRefferedByDoctors: "doctors/listRefferedByDoctors",
      getDiscountList: "doctors/getDiscountList",
      listServices: "services/listServices",
      getTokenNo: "receptionist/getTokenNo",
      fetchBranch: "expenses/fetchBranch",
      currentSelectBranch: "expenses/currentSelectBranch",
      gettAllCharges: "services/gettAllCharges",
      getAllLookUps: "bussiness/getAllLookUps"
    }),
    handleFromReset() {
      this.resetForm();
      this.resetSearch = !this.resetSearch;
    },
    suggestion(val) {
      this.searchResult = val;
      this.referredBy.name = val.referredBy;
      this.refferedTo = {
        name: this?.searchResult?.user?.employ?.full_name,
        id: this?.searchResult?.userId
      };
      this.searchResult.age = formatAgeYear(
        this?.searchResult?.updated_at,
        this?.searchResult?.age
      );
      this.userGender = formatGender(
        this.searchResult && this.searchResult.gender
      );
      this.patientDetails = { ...this.searchResult };
    },
    handlePatientSearch(val) {
      this.handleSearchPatientValue = val;
    },
    async handleSearchPatient() {
      const val = this.handleSearchPatientValue;
      if (Array.isArray(this.queryResult) && this.queryResult.length === 1) {
        this.suggestions = [];
      }
      if (!val) {
        this.$toasted
          .show("Please enter a MR NO or MOBILE NUMBER")
          .goAway("3000");
      } else if (val.startsWith("0") && val.length === 11) {
        this.isLoading = true;
        await this.searchPatient(val)
          .then(() => {
            this.refferedTo = {
              name: this?.searchResult?.user?.employ?.full_name,
              id: this?.searchResult?.userId
            };
            this.searchResult.age = formatAgeYear(
              this?.searchResult?.updated_at,
              this?.searchResult?.age
            );
            this.userGender = formatGender(
              this.searchResult && this.searchResult.gender
            );
            this.referredBy.name = this.searchResult?.referredBy;
            this.patientDetails = { ...this.searchResult };

            this.isLoading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else if (!val.startsWith("0")) {
        this.isLoading = true;
        await this.searchPatient(val)
          .then(() => {
            this.refferedTo = {
              name: this?.searchResult?.user?.employ?.full_name,
              id: this?.searchResult?.userId
            };
            this.searchResult.age = formatAgeYear(
              this?.searchResult?.updated_at,
              this?.searchResult?.age
            );
            this.userGender = formatGender(
              this.searchResult && this.searchResult.gender
            );
            this.referredBy.name = this.searchResult?.referredBy;
            this.patientDetails = { ...this.searchResult };
            this.isLoading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    handleRefferedTo(val) {
      if (val) {
        this.refferedTo = val;
      } else {
        this.refferedTo = {};
      }
    },
    handlerefferedBy(val) {
      if (val) {
        this.referredBy = val;
      } else {
        this.referredBy = {};
      }
    },
    invoiceItems(val, id) {
      handleRows(val, id, this.serviceRows);
    },
    handleQuantity(val, id) {
      this.currentId = id;
      if (val > 0) {
        const rowsState = [...this.serviceRows];
        this.grandTotal = rowsState
          .reduce((acc, item) => acc + item.price * item.quantity, 0)
          .toLocaleString();
        handleQuantityNumber(val, id, this.serviceRows);
      }
    },
    handleDiscount(val, id) {
      const rowsState = [...this.serviceRows];
      const index = rowsState.findIndex(i => i.id == id);
      if (index > -1 && rowsState[index].subtotal) {
        const value = rowsState[index].price * rowsState[index].quantity;
        rowsState[index].subtotal = value - val;
        const totalPercentage = (val / value) * 100;
        rowsState[index].discountPercentageValue = totalPercentage.toFixed(2);
        this.serviceRows = rowsState;
      }
    },
    handleDiscountPercentAge(val, id) {
      if (val >= 0) {
        const rowsState = [...this.serviceRows];
        const index = rowsState.findIndex(i => i.id == id);
        if (index > -1 && rowsState[index].subtotal) {
          const discount_amount =
            (val / 100) * rowsState[index].price * rowsState[index].quantity;
          rowsState[index].discountValue = discount_amount.toFixed(2);
          const total_amount =
            rowsState[index].price * rowsState[index].quantity -
            discount_amount;
          rowsState[index].subtotal = total_amount.toFixed(2);
          rowsState[index].subtotal = val === 0 ? 0 : total_amount.toFixed(2);
          this.serviceRows = rowsState;
        }
      }
    },
    handleInvoiceItems() {
      this.serviceRows.push({
        id: this.serviceRows[0].id++,
        price: 0,
        subtotal: 0,
        discountValue: 0,
        quantity: 1,
        discountPercentageValue: 0
      });
    },
    handleDeleteItem(val) {
      const rowsState = [...this.serviceRows];
      const index = rowsState.findIndex(i => i.id == val.id);
      const total = val.price * val.quantity;

      const subtotal =
        typeof this.grandTotal === "string"
          ? Number(this.grandTotal.replace(/[, ]+/g, ""))
          : this.grandTotal;
      this.grandTotal = subtotal - total;

      if (val !== null) {
        rowsState[index].subtotal = 0;
        rowsState[index].discountValue = 0;
        rowsState[index].price = 0;
        rowsState[index].discountPercentageValue = 0;
        rowsState[index].name = "";
        rowsState[index].chargeId = 0;
      }

      for (var i = 0; i < this.serviceRows.length; i++)
        if (this.serviceRows[i].id && this.serviceRows[i].id === val.id) {
          if (this.serviceRows.length > 1) {
            this.serviceRows.splice(i, 1);
          }
          break;
        }
      if (this.serviceRows[0]?.price === 0) {
        this.discountToggle = true;
        this.discountTypeId = null;
      }
    },
    handleSave() {
      if (this.isRegistrationsLoading) return; // Prevent multiple clicks
      try {
        this.isRegistrationsLoading = true; // Set loading state at the start
        this.getInvoiceNumber(this.selectedBranchId).then(() => {
          this.invoiceNo = this.invoiceNumber;
          const charges = this?.serviceRows.map(item => ({
            chargeId: item?.chargeId,
            discount: item?.discountValue,
            amount: item?.price,
            lookupId: item?.lookupId,
            quantity: item?.quantity,
            discountPercentage: item?.discountPercentageValue
          }));
          const history = {
            charges,
            isEnsourance: this.isInsurance ? 1 : 0,
            recievable: this.isInsurance ? this.sumValue : null,
            companyName: this.isInsurance ? this.company : null,
            invoice_no: this.invoiceNo,
            isOther: this.isOther !== "Radiology" ? 1 : 0,
            isGenAppt: this.isOther === "Doctor" ? true : false,
            branchId: this.selectedBranchId
          };
          this.$refs.observer.validate().then(success => {
            if (!success) {
              this.isRegistrationsLoading = false; // Reset loading if validation fails
              return;
            }
            if (this.serviceRows.some(item => item.lookup)) {
              let uniqueValues = [
                ...new Set(
                  this.serviceRows && this.serviceRows.map(item => item.lookup)
                )
              ];
              const tokens = {
                date: moment().format("YYYY-MM-DD HH:mm:ss"),
                serviceHead: uniqueValues,
                refferedTo: this.refferedTo.id,
                mediRed: this.isOther !== "Radiology" ? false : true,
                branchId: this.selectedBranchId
              };
              this.isDoubleInvoicePrint =
                (tokens.serviceHead.includes("ULTRASOUND") && tokens.mediRed) ||
                (tokens.serviceHead.includes("MRI") && tokens.mediRed) ||
                (tokens.serviceHead.includes("CT") && tokens.mediRed)
                  ? true
                  : false;
              let payload = {
                ...this.patientDetails,
                ...history,
                gender: getGender(this.userGender),
                refferedTo: this.refferedTo.id,
                referredBy: this.referredBy.name,
                lookupId: this.referredBy.id,
                isOther: this.isOther !== "Radiology" ? 1 : 0,
                isGenAppt: this.isOther === "Doctor" ? true : false,
                performed_on: moment().format("YYYY-MM-DD HH:mm:ss"),
                branchId: this.selectedBranchId,
                invoice_status: this.invoiceStatus
              };
              console.log(formatedDate());

              this.getTokenNo(tokens)
                .then(() => {
                  if (Object.keys(this.searchResult).length === 0) {
                    if (charges && charges.length > 0) {
                      // Map tokens to their corresponding service heads
                      if (
                        this.tokens &&
                        Array.isArray(this.tokens) &&
                        this.tokens.length > 0
                      ) {
                        // Create a mapping of service head to token
                        const tokenMap = {};
                        this.tokens.forEach(token => {
                          tokenMap[token.serviceHead] = token.visits;
                        });

                        // Assign tokens to charges based on lookupId
                        const updatedCharges = charges.map(charge => {
                          // Find the service for this charge
                          const service = this.serviceRows.find(
                            s => s.chargeId === charge.chargeId
                          );
                          if (service && service.lookup) {
                            // If this service has a lookup that matches a token, add the token
                            if (tokenMap[service.lookup]) {
                              return {
                                ...charge,
                                token: tokenMap[service.lookup]
                              };
                            }
                          }
                          return charge;
                        });

                        // Replace the charges in the payload
                        payload = {
                          ...payload,
                          charges: updatedCharges
                        };
                      }
                      const sendSms =
                        this.validateSessionStatus?.messageSettings
                          ?.receptionMessage || false;
                      this.addPatient({
                        payload: payload,
                        vm: this,
                        sendSms: sendSms
                      })
                        .then(() => {
                          if (this.addPatientStatus === 201) {
                            const { mr_no } = this.registerPatient;
                            if (mr_no) {
                              const details = {
                                mrNo: mr_no,
                                invoiceNo: this.invoiceNo
                              };
                              this.handlePrint(details);
                            }
                            this.updateTokenStatus({
                              id: this.registerPatient.id,
                              visits: this.tokens
                            });
                            this.finishSubmitAfterPrint();
                          } else {
                            this.$toasted
                              .error(
                                "Something went wrong, please try again. Thanks"
                              )
                              .goAway("3000");
                          }
                        })
                        .catch(() => {
                          this.$refs.observer.reset();
                          this.resetForm();
                          this.invoiceNo = null;
                        })
                        .finally(() => {
                          this.isRegistrationsLoading = false; // Reset loading state
                        });
                    } else {
                      this.$toasted
                        .show("Please add a service to proceed")
                        .goAway("3000");
                      this.isRegistrationsLoading = false;
                    }
                  } else {
                    this.getInvoiceNumber(this.selectedBranchId).then(() => {
                      const updateItems = {
                        lookupId: this.referredBy.id,
                        referredBy: this.referredBy.name,
                        refferedTo: this.refferedTo.id,
                        performed_on: moment().format("YYYY-MM-DD HH:mm:ss"),
                        age: this.patientDetails.age,
                        branchId: this.selectedBranchId,
                        contactNumber: this.patientDetails.contactNumber
                      };
                      if (charges && charges.length > 0) {
                        if (permissionsMiddleWare("Update Patient")) {
                          if (this.searchResult.id !== "undefined") {
                            this.updateDetails({
                              id: this.searchResult.id,
                              user: updateItems
                            })
                              .then(() => {
                                const tokenMap = {};
                                this.tokens.forEach(token => {
                                  tokenMap[token.serviceHead] = token.visits;
                                });
                                const updatedCharges = charges.map(charge => {
                                  const service = this.serviceRows.find(
                                    s => s.chargeId === charge.chargeId
                                  );
                                  if (service && service.lookup) {
                                    if (tokenMap[service.lookup]) {
                                      return {
                                        ...charge,
                                        token: tokenMap[service.lookup]
                                      };
                                    }
                                  }
                                  return charge;
                                });

                                const reqPayload = {
                                  ...history,
                                  charges: updatedCharges
                                };
                                this.addHistory({
                                  ...reqPayload,
                                  patientId: this.searchResult.id,
                                  refferedTo: this.refferedTo.id
                                })
                                  .then(() => {
                                    if (this.historyStatus === 201) {
                                      this.$toasted
                                        .success(
                                          "Patient details added successfully"
                                        )
                                        .goAway("3000");
                                      const { mr_no } = this.searchResult || {};
                                      if (mr_no) {
                                        const details = {
                                          mrNo: mr_no,
                                          invoiceNo: this.invoiceNo
                                        };
                                        this.handlePrint(details);
                                      }
                                    } else {
                                      this.$toasted
                                        .error(
                                          "Something went wrong please try again. Thanks"
                                        )
                                        .goAway("3000");
                                    }
                                    this.listPatients();
                                    this.updateTokenStatus({
                                      id: this.searchResult.id,
                                      visits: this.tokens
                                    });
                                    this.finishSubmitAfterPrint();
                                  })
                                  .catch(() => {
                                    this.resetForm();
                                    this.invoiceNo = null;
                                    this.$refs.observer.reset();
                                  })
                                  .finally(() => {
                                    this.isRegistrationsLoading = false;
                                  });
                              })
                              .catch(() => {
                                this.resetForm();
                                this.invoiceNo = null;
                                this.$refs.observer.reset();
                                this.isRegistrationsLoading = false;
                              });
                          } else {
                            this.$toasted
                              .error("User Id missing Please try again.")
                              .goAway("3000");
                            this.isRegistrationsLoading = false;
                          }
                        } else {
                          this.$toasted
                            .info(
                              "This action cannot be performed by you due to insufficient authorization. Action : Update Patient"
                            )
                            .goAway("3000");
                          this.isRegistrationsLoading = false;
                        }
                      } else {
                        this.$toasted
                          .success("Please add a service to proceed")
                          .goAway("3000");
                        this.isRegistrationsLoading = false;
                      }
                    });
                  }
                })
                .catch(() => {});
            } else {
              this.$toasted.show("Please update service head").goAway("3000");
              this.isRegistrationsLoading = false;
            }
          });
        });
      } catch (error) {
        this.invoiceNo = null;
        this.isRegistrationsLoading = false;
        this.$toasted.message("Error occured").goAway("3000");
      }
    },
    onThermalPrinterMockChanged(event) {
      const { connected, name } = event.detail || {};
      this.printerIsConnected = Boolean(connected);
      this.printerName = name || "";
    },
    savePrinterType() {
      localStorage.setItem("printer_type", this.printerType);
      this.$toasted
        .success(`Printer type set to ${this.printerType}`)
        .goAway(3000);

      // If switched to Thermal, try to auto-connect
      if (this.printerType === "Thermal") {
        this.checkPrinterConnection();
      }
    },
    async checkPrinterConnection() {
      const thermalService = ThermalPrintService.getInstance();
      if (thermalService.isMockMode()) {
        await thermalService.autoConnect();
        this.printerIsConnected = thermalService.isConnected;
        this.printerName = thermalService.deviceName;
        return;
      }
      if (thermalService.isSupported()) {
        try {
          const devices = await navigator.usb.getDevices();
          if (devices.length > 0) {
            this.printerIsConnected = true;
            this.printerName = devices[0].productName || "USB Printer";
          } else {
            // Attempt auto-connect if device was previously authorized
            await thermalService.autoConnect();
            this.printerIsConnected = thermalService.isConnected;
            this.printerName = thermalService.deviceName;
          }
        } catch (err) {
          console.warn("[ThermalPrint] Silent connection check failed:", err);
        }
      }
    },
    async handlePrint(details) {
      const getServiceHeader = (type, rows) => {
        const lookup = rows?.[0]?.lookup;
        if (type === "Radiology" && lookup) return lookup.toUpperCase();
        if (type === "Radiology") return "ULTRASOUND";
        return type.toUpperCase();
      };

      // Capture detailed snapshot BEFORE potential form reset
      const thermalData = {
        organizationName: this.user?.bussiness?.name || "Family Hospital",
        mrNo: details.mrNo,
        token: this.tokens?.[0]?.visits || "-",
        serviceHeader: getServiceHeader(this.isOther, this.serviceRows),
        patientName: this.patientDetails.name,
        fatherHusbandName:
          this.patientDetails.fatherOrHusbandName ||
          this.searchResult?.fatherOrHusbandName ||
          "-",
        age: this.patientDetails.age,
        gender: this.userGender,
        invoiceNo: details.invoiceNo,
        date: moment().format("DD/MM/YYYY"),
        referredBy: this.referredBy.name,
        panelName: this.isInsurance ? this.company : null,
        invoiceStatus: this.invoiceStatus,
        rows: this.serviceRows.map(item => ({
          service: item.name,
          price: item.price,
          subtotal: item.subtotal
        })),
        total: this.grandTotal,
        discount: this.discountAmount,
        netTotal: this.sumValue,
        printedBy: this.user.full_name,
        printDate: moment().format("dddd, MMMM Do, YYYY, h:mm:ss a")
      };

      if (this.printerType === "A4") {
        this.a4PrintPatient = this.buildPrintPatient(details);
        await this.$nextTick();
        this.isOther === "Doctor"
          ? printDiv("externalInvoice", details)
          : printDiv("print-invoice", details);
        return;
      }

      // Thermal Printing - Show Confirmation Modal
      this.a4PrintPatient = this.buildPrintPatient(details);
      this.printDetailsData = {
        apiResponse: details,
        thermalData: thermalData,
        isDoctorAppointment: this.isOther === "Doctor",
        a4PrintSnapshot: this.captureA4PrintSnapshot(details)
      };
      this.printPatientCopy = true;
      this.printOfficialCopy = false;

      // Try to auto-connect if not already connected
      const thermalService = ThermalPrintService.getInstance();
      if (!thermalService.isConnected) {
        await thermalService.autoConnect();
      }
      this.printerIsConnected = thermalService.isConnected;
      this.printerName = thermalService.deviceName;

      this.$modal.show("printConfirmation");
    },
    buildPrintPatient(details = {}) {
      const fromSearch =
        this.searchResult && Object.keys(this.searchResult).length > 0
          ? this.searchResult
          : null;
      const fromForm = this.patientDetails || {};
      const fromRegister = this.registerPatient || {};
      return {
        name: fromForm.name || fromSearch?.name || fromRegister.name,
        fatherOrHusbandName:
          fromForm.fatherOrHusbandName ||
          fromSearch?.fatherOrHusbandName ||
          fromRegister.fatherOrHusbandName,
        age: fromForm.age || fromSearch?.age || fromRegister.age,
        mr_no:
          details.mrNo ||
          fromForm.mr_no ||
          fromSearch?.mr_no ||
          fromRegister.mr_no,
        address:
          fromForm.address || fromSearch?.address || fromRegister.address,
        gender:
          fromForm.gender ||
          fromSearch?.gender ||
          this.userGender ||
          fromRegister.gender
      };
    },
    captureA4PrintSnapshot(details) {
      const printPatient = this.buildPrintPatient(details);
      return {
        invoiceNo: details.invoiceNo,
        isOther: this.isOther,
        serviceRows: JSON.parse(JSON.stringify(this.serviceRows)),
        printPatient,
        patientDetails: {
          ...this.patientDetails,
          gender: this.userGender
        },
        searchResult: {
          ...this.searchResult,
          gender: this.searchResult.gender || this.userGender
        },
        refferedTo: { ...this.refferedTo },
        referredBy: { ...this.referredBy },
        userGender: this.userGender,
        selectedDiscountType: this.selectedDiscountType
      };
    },
    restoreA4PrintSnapshot(snapshot) {
      if (!snapshot) return;
      this.invoiceNo = snapshot.invoiceNo;
      this.isOther = snapshot.isOther;
      this.serviceRows = snapshot.serviceRows;
      this.a4PrintPatient = snapshot.printPatient || null;
      this.patientDetails = snapshot.patientDetails;
      this.searchResult = snapshot.searchResult;
      this.refferedTo = snapshot.refferedTo;
      this.referredBy = snapshot.referredBy;
      this.userGender = snapshot.userGender;
      this.selectedDiscountType = snapshot.selectedDiscountType;
    },
    finishSubmitAfterPrint() {
      if (this.printerType === "A4") {
        this.isOther = "Radiology";
        this.$refs.observer.reset();
        this.resetForm();
        this.invoiceNo = null;
      }
    },
    onPrintModalClosed() {
      // printDiv captures HTML after 1s — do not reset while A4 prescription
      // print is pending, or MR-search patients lose demographics (new patients
      // still worked via leftover Vuex registerPatient).
      if (
        this.printDetailsData &&
        !this.printInProgress &&
        !this.a4PrescriptionOnly
      ) {
        this.resetFormAfterPrint();
      }
    },
    async connectPrinter() {
      try {
        const thermalService = ThermalPrintService.getInstance();
        const name = await thermalService.requestDevice();
        this.printerIsConnected = true;
        this.printerName = name;
        const label = thermalService.isMockMode()
          ? `Mock printer ready: ${name}`
          : `Printer connected: ${name}`;
        this.$toasted.success(label).goAway(3000);
      } catch (error) {
        if (process.env.NODE_ENV === "development") {
          ThermalPrintService.enableMockMode();
          this.printerIsConnected = true;
          this.printerName = "Mock Thermal Printer (Dev)";
          this.$toasted
            .success("Using mock thermal printer (dev mode)")
            .goAway(3000);
          return;
        }
        console.error("Connection failed:", error);
        this.$toasted.error("Failed to connect to printer").goAway(3000);
      }
    },
    async executePrint() {
      if (!this.printDetailsData) return;
      const {
        apiResponse,
        thermalData,
        isDoctorAppointment
      } = this.printDetailsData;

      this.printInProgress = true;
      let deferResetForA4 = false;
      try {
        const thermalService = ThermalPrintService.getInstance();
        const printOptions = {
          printPatient: this.printPatientCopy,
          printOfficial: this.printOfficialCopy
        };
        console.log("thermalData", thermalData);
        await thermalService.printCustom(
          thermalData,
          this.isOther,
          printOptions
        );
        this.$modal.hide("printConfirmation");
        this.printerIsConnected = thermalService.isConnected;

        // After thermal, auto-print doctor prescription on A4 when applicable.
        if (isDoctorAppointment && this.printPatientCopy) {
          this.pendingA4AfterThermal = apiResponse;
          deferResetForA4 = true;
          await this.printA4AfterThermal();
          return;
        }

        // Comprehensive form reset after successful print
        this.resetFormAfterPrint();
      } catch (error) {
        console.error("Thermal printing failed:", error);
        this.printerIsConnected = false;
        this.$toasted
          .error("Thermal printing failed. Switching to A4...")
          .goAway(3000);
        this.$modal.hide("printConfirmation");
        const { isDoctorAppointment, a4PrintSnapshot } = this.printDetailsData;
        this.restoreA4PrintSnapshot(a4PrintSnapshot);
        this.a4PrescriptionOnly = !!isDoctorAppointment;
        deferResetForA4 = true;
        await this.$nextTick();
        isDoctorAppointment
          ? printDiv("externalInvoice", apiResponse)
          : printDiv("print-invoice", apiResponse);

        // printDiv captures after 1s — reset only after capture
        setTimeout(() => {
          this.a4PrescriptionOnly = false;
          this.printInProgress = false;
          this.resetFormAfterPrint();
        }, 2000);
      } finally {
        if (!deferResetForA4) {
          this.printInProgress = false;
        }
      }
    },
    skipA4AfterThermal() {
      this.$modal.hide("a4AfterThermal");
      this.pendingA4AfterThermal = null;
      this.resetFormAfterPrint();
    },
    async printA4AfterThermal() {
      const details = this.pendingA4AfterThermal;
      const snapshot = this.printDetailsData?.a4PrintSnapshot;
      this.$modal.hide("a4AfterThermal");
      this.pendingA4AfterThermal = null;
      if (details) {
        this.restoreA4PrintSnapshot(snapshot);
        this.a4PrescriptionOnly = true;
        await this.$nextTick();
        await this.$nextTick();
        const prescriptionEl = document.getElementById("externalInvoice");
        recordA4Prescription({
          patient: this.a4PrintPatient || this.invoicePatient,
          invoiceNo: this.invoiceNo,
          html: prescriptionEl ? prescriptionEl.innerText : ""
        });
        printDiv("externalInvoice", details);
        // printDiv captures HTML after 1s — keep data until then
        setTimeout(() => {
          this.a4PrescriptionOnly = false;
          this.printInProgress = false;
          this.resetFormAfterPrint();
        }, 2000);
        return;
      }
      this.printInProgress = false;
      this.resetFormAfterPrint();
    },
    async switchToA4() {
      if (!this.printDetailsData) return;
      const {
        apiResponse,
        a4PrintSnapshot,
        isDoctorAppointment
      } = this.printDetailsData;
      this.printInProgress = true;
      this.restoreA4PrintSnapshot(a4PrintSnapshot);
      await this.$nextTick();
      this.$modal.hide("printConfirmation");
      isDoctorAppointment
        ? printDiv("externalInvoice", apiResponse)
        : printDiv("print-invoice", apiResponse);
      this.printDetailsData = null;
      this.printInProgress = false;
    },
    handleAddDoctor() {
      this.$modal.show("doctorsAdd");
    },
    resetForm() {
      this.$refs.observer.reset();
      this.patientDetails = {};
      this.searchResult = {};
      this.refferedTo = {};
      this.referredBy = {};
      this.registrationId = "";
      this.userGender = "";
      this.company = "";
      this.isInsurance = false;
      this.serviceRows = [
        {
          id: 1,
          service: "",
          price: 0,
          subtotal: 0,
          discountValue: null,
          quantity: null,
          lookupId: null,
          discountPercentageValue: null,
          serviceId: null
        }
      ];
    },
    resetFormAfterPrint() {
      // 1. Reset form validation
      if (this.$refs.observer) {
        this.$refs.observer.reset();
      }

      // 2. Reset Patient Information section
      this.patientDetails = {};
      this.searchResult = {};
      this.userGender = "";

      // 3. Reset Referred By / Referred To
      this.referredBy = {};
      this.refferedTo = {};

      // 4. Reset top search patient option
      this.handleSearchPatientValue = "";
      this.suggestions = [];
      this.resetSearch = !this.resetSearch; // Triggers search component reset

      // 5. Reset Service Selection section
      this.serviceRows = [
        {
          id: 1,
          service: "",
          price: 0,
          subtotal: 0,
          discountValue: 0,
          quantity: 1,
          lookupId: null,
          discountPercentageValue: 0,
          serviceId: null,
          branchId: null
        }
      ];

      // 6. Reset Totals section
      this.grandTotal = 0;

      // 7. Reset Insurance and Company
      this.isInsurance = false;
      this.company = "";

      // 8. Reset Invoice related
      this.invoiceNo = null;
      this.registrationId = "";

      // 9. Reset Invoice Type to default (Radiology)
      this.isOther = "Radiology";

      // 10. Reset Discount fields
      this.discountTypeId = null;
      this.selectedDiscountType = "";

      // 11. Reset print-related states
      this.printDetailsData = null;
      this.a4PrintPatient = null;
      this.printPatientCopy = true;
      this.printOfficialCopy = false;

      // 12. Reset loading states
      this.isRegistrationsLoading = false;

      this.$toasted.success("Form reset successfully!").goAway(2000);
    },
    handleDiscountTpye(val) {
      if (val && val !== null) {
        this.discountTypeId = val.key;
        this.selectedDiscountType = val.name;
        this.company = val.name;
        this.invoiceStatus = 2;
        let arr = [];
        this.serviceRows.filter(item => {
          item.discountValue = 0;
          item.discountPercentageValue = 0;
          item.subtotal = item.price * item.quantity;
        });

        this.serviceRows.forEach(item => arr.push(item.serviceId));

        const dataItems = this.lookUpSetting.filter(
          item => item.lookupId == val.key
        );

        const data = dataItems.filter(obj => {
          return arr.includes(obj.serviceId);
        });

        data.filter(item => {
          this.serviceRows.map(itemData => {
            if (
              item.serviceId == itemData?.serviceId &&
              item.branchId == this.selectedBranchId
            ) {
              itemData.discountValue = item.discount;
              const total = itemData?.quantity * item?.amount;
              const discountVal = itemData?.discountValue;
              itemData.subtotal = total - discountVal;
              itemData.price = item.amount;
              itemData.discountPercentageValue = calculateDiscountPercent(
                total,
                discountVal
              ).toFixed(2);
            }
            this.grandTotal = this.serviceRows
              .reduce((acc, item) => acc + item.price * item.quantity, 0)
              .toLocaleString();
          });
        });
      }
      if (val == null) {
        this.discountTypeId = null;
        this.selectedDiscountType = null;
        this.organizationDiscount = null;
        this.company = "";
        this.invoiceStatus = 1;
        // Restore default branch charges (panel amount was written into price)
        this.serviceRows = this.serviceRows.map(item => {
          const charge = this.allCharges.find(
            c =>
              c.serviceId == item.serviceId &&
              c.branchId == this.selectedBranchId
          );
          const price = charge?.amount ?? item.price;
          return {
            ...item,
            price,
            discountPercentageValue: 0,
            discountValue: 0,
            subtotal: item.quantity * price
          };
        });
        this.grandTotal = this.serviceRows
          .reduce((acc, item) => acc + item.price * item.quantity, 0)
          .toLocaleString();
      }
    },
    handleServiceSelect(val, services) {
      if (val && val !== null) {
        this.invoiceItems(val, services.id);
        this.toggle = true;
        this.discountToggle = false;
        const data = this.allCharges.filter(
          item =>
            item.serviceId === val.serviceId &&
            item.branchId === this.selectedBranchId
        );

        // Update service rows
        const rowsState = [...this.serviceRows];
        const index = rowsState.findIndex(i => i.id == services.id);

        if (index > -1) {
          // Update price and service ID
          rowsState[index].price =
            data?.length > 1 ? data[0].amount : val.amount;
          rowsState[index].serviceId = val.serviceId;

          // Recalculate subtotal and discount
          const total = rowsState[index].price * rowsState[index].quantity;
          const discountValue = rowsState[index].discountValue;
          rowsState[index].subtotal = total - discountValue;
          if (this.discountTypeId && this.discountTypeId !== null) {
            // Use == — API ids may be number while Select keys are string
            const discountData = this.lookUpSetting.find(
              item =>
                item.serviceId == val.serviceId &&
                item.branchId == this.selectedBranchId &&
                item.lookupId == this.discountTypeId
            );
            if (discountData) {
              rowsState[index].price = discountData.amount;
              const total = rowsState[index].price * rowsState[index].quantity;
              rowsState[index].discountValue = discountData.discount;
              const discountPercent = calculateDiscountPercent(
                total,
                discountData.discount
              );
              rowsState[
                index
              ].discountPercentageValue = discountPercent.toFixed(2);
              rowsState[index].subtotal = (
                total - discountData.discount
              ).toFixed(0);
            }
          }
        }

        // Update grand total
        this.grandTotal = rowsState
          .reduce((acc, item) => acc + item.price * item.quantity, 0)
          .toLocaleString();

        // Add new invoice item
      }
    },
    async handleBranchChange(val) {
      if (val && val !== null) {
        // Settings are fetched per branch — load the new branch's before
        // the discount recalculation below reads lookUpSetting
        await this.getAllLookUps({ id: val.key });
      }
      if (val && val !== null && this.serviceRows[0].price !== 0) {
        //reseting servive row before branch change
        this.serviceRows.filter(item => {
          item.discountValue = 0;
          item.discountPercentageValue = 0;
          item.subtotal = item.price * item.quantity;
        });

        const serviceIds = this.serviceRows.map(item => {
          return item.serviceId;
        });

        const data = this.allCharges.filter(item =>
          serviceIds.includes(item.serviceId)
        );

        const filteredData = data?.map(item => {
          return {
            amount: item?.amount,
            branchId: item?.branchId,
            serviceId: item?.serviceId
          };
        });

        let arr2 = [];

        const dto = filteredData.filter(item => item.branchId === val.key);

        dto.forEach(item => {
          arr2.push(item.serviceId);
        });

        const msdfData = this.serviceRows?.filter(item =>
          arr2?.includes(item.serviceId)
        );

        dto.filter(item => {
          msdfData.filter(itemData => {
            if (item.serviceId === itemData.serviceId) {
              itemData.price = item.amount;
              itemData.subtotal = itemData.price * itemData.quantity;
            }
          });
        });
        if (this.discountTypeId && this.discountTypeId !== null) {
          this.serviceRows.filter(item => {
            item.discountValue = 0;
            item.discountPercentageValue = 0;
          });
          let arr = [];
          this.serviceRows?.forEach(item => arr.push(item?.serviceId));

          const dataItems = this.lookUpSetting.filter(
            item =>
              item.lookupId == this.discountTypeId && item.branchId == val.key
          );

          const dataDto = dataItems.filter(obj => {
            return arr.includes(obj.serviceId);
          });

          // Apply panel rate (amount) + fixed discount for this branch
          dataDto?.filter(item => {
            this.serviceRows.map(itemData => {
              if (
                item.serviceId == itemData?.serviceId &&
                item.branchId == val.key
              ) {
                itemData.price = item.amount;
                itemData.discountValue = item.discount;
                const total = itemData.quantity * itemData.price;
                const discountVal = itemData.discountValue;
                itemData.subtotal = total - discountVal;
                itemData.discountPercentageValue = calculateDiscountPercent(
                  total,
                  discountVal
                ).toFixed(2);
              }
            });
          });
        }
        //Setting grand total
        this.grandTotal = this.serviceRows
          .reduce((acc, item) => acc + item.price * item.quantity, 0)
          .toLocaleString();
      }

      if (val && val != null) {
        const object = getBranchLogo(this.fetchUserBranch, val.key);
        this.branchLogoUrl = object;
        this.selectedBranchId = val.key;
      }
    },
    async loadRegistrationData() {
      this.isPreparingData = true;
      this.registrationDataFailed = false;
      this.isLoadingRefferedBy = true;
      this.isLoadingRefferedTo = true;
      const refferedByPromise = Promise.all([
        this.listRefferedByDoctors("doctor"),
        this.listRefferedByDoctors("hospital")
      ]).finally(() => (this.isLoadingRefferedBy = false));
      const doctorsPromise = this.listDoctors().finally(
        () => (this.isLoadingRefferedTo = false)
      );
      const servicesPromise = this.listServices();
      await Promise.allSettled([
        refferedByPromise,
        doctorsPromise,
        servicesPromise
      ]);
      this.isPreparingData = false;
      this.registrationDataFailed = this.missingRegistrationData.length > 0;
    }
  },
  computed: {
    ...mapGetters({
      listItems: "services/listItems",
      queryResult: "receptionist/searchResult",
      invoiceNumber: "receptionist/invoiceNumber",
      registerPatient: "receptionist/registerPatient",
      doctorsList: "receptionist/doctorsList",
      refferedByDoctors: "doctors/refferedByDoctors",
      discountList: "doctors/discountList",
      fetchUserBranch: "expenses/fetchUserBranch",
      user: "auth/userInfo",
      loading: "loading",
      settings: "bussiness/settings",
      allCharges: "services/allCharges",
      lookUpSetting: "bussiness/lookUpSetting",
      historyStatus: "receptionist/historyStatus",
      addPatientStatus: "receptionist/addPatientStatus",
      tokens: "receptionist/tokens",
      validateSessionStatus: "auth/validateSessionStatus"
    }),
    sumValue() {
      return sum(this.serviceRows);
    },
    branchPlaceHolder() {
      const data = this.fetchUserBranch?.find(
        e => this.selectedBranchId == e.id
      );
      return data?.name;
    },
    discountAmount() {
      const data = this.serviceRows.map(item => {
        return item.discountValue;
      });
      const final_amount = data.reduce(
        (total, num) => Number(total) + Number(num),
        0
      );
      return final_amount;
    },
    refferedDoctor() {
      return (
        this.doctorsList &&
        this.doctorsList.map(item => ({
          name: item.full_name,
          id: item.id
        }))
      );
    },
    missingRegistrationData() {
      const missing = [];
      if (!this.refferedByDoctors?.length) missing.push("Referred By");
      if (!this.refferedDoctor?.length) missing.push("Referred To");
      if (!this.servicesList.length) missing.push("Services");
      return missing;
    },
    servicesList() {
      const items = [];
      this.listItems &&
        this.listItems.map(item => {
          items.push({
            id: item.service.id,
            name: item.service.name,
            lookup: item?.service?.lookup?.name,
            lookupId: item?.service?.lookup?.id,
            amount: item.amount,
            chargeId: item.id,
            serviceId: item.serviceId
          });
        });
      return items;
    },
    discountType() {
      const results = this.discountList?.map(obj => ({
        key: obj?.id,
        name: obj?.name
      }));
      return results;
    },
    currentDate() {
      return moment().format("D/M/Y");
    },
    serviceRowsPrint() {
      return this.serviceRows.map(({ discountValue, ...rest }) => {
        if (discountValue === 0) {
          return rest;
        }
        return { discountValue, ...rest };
      });
    },
    invoicePatient() {
      if (this.a4PrintPatient && this.a4PrintPatient.name) {
        return this.a4PrintPatient;
      }
      return this.buildPrintPatient({
        mrNo: this.patientDetails.mr_no || this.searchResult?.mr_no,
        invoiceNo: this.invoiceNo
      });
    }
  },
  watch: {
    queryResult(val) {
      if (Array.isArray(val) && val.length === 1) {
        this.searchResult = val.find(item => item);
        this.referredBy.name = val.find(item => item)?.val?.referredBy;
      } else {
        this.suggestions = val;
      }
    },
    toggle() {
      this.discountToggle = false;
    }
  },
  async mounted() {
    // Keeps the banner up until Referred By, Referred To and Services have
    // actually loaded — a failure in the awaits below must not block them
    this.loadRegistrationData();

    // Branch dropdown + default selection first — they must not wait
    // behind the heavier calls below
    await this.fetchBranch();
    this.fetchUserBranch?.map(elem => {
      this.brachData.push({ name: elem.name, key: elem.id });
    });
    const object = getBranchLogo(this.fetchUserBranch, this.user?.userBranchId);
    this.branchLogoUrl = object;
    this.bussinessLogoUrl = this.user?.bussinessLogoUrl;
    this.currentSelectBranch(object);
    this.selectedBranchId = this.user?.userBranchId;

    // Scoped to the user's branch — unscoped, this endpoint returns the
    // whole tenant's settings (megabytes, minutes)
    await this.getAllLookUps({ id: this.user?.userBranchId });
    await this.gettAllCharges();
    await this.getDiscountList();

    this.serviceRows.forEach(item => {
      item.originalSubtotal = item.subtotal;
      // arr.push(item.serviceId);
    });
    setTimeout(() => {
      this.$store.dispatch("auth/userLoginProgress", false);
    }, 3000);

    // Initial printer connection check
    if (this.printerType === "Thermal") {
      this.checkPrinterConnection();
    }
    window.addEventListener(
      "thermal-printer-mock-changed",
      this.onThermalPrinterMockChanged
    );
  },
  beforeDestroy() {
    window.removeEventListener(
      "thermal-printer-mock-changed",
      this.onThermalPrinterMockChanged
    );
  }
};
</script>

<style>
#print-invoice {
  margin: 0;
  padding: 0;
}

.preparing-data-banner {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 2rem;
  background: #f3effb;
  color: #6d4dc7;
  font-size: 0.85rem;
  border-bottom: 1px solid var(--line);
}

.preparing-data-banner--failed {
  background: #fdf1f0;
  color: #c0392b;
}

.preparing-data-retry {
  border: 1px solid currentColor;
  background: transparent;
  color: inherit;
  border-radius: 4px;
  padding: 0.1rem 0.6rem;
  font-size: 0.8rem;
  cursor: pointer;
}

.preparing-data-spinner {
  width: 0.9rem;
  height: 0.9rem;
  border: 2px solid #6d4dc7;
  border-top-color: transparent;
  border-radius: 50%;
  animation: preparing-data-spin 0.8s linear infinite;
}

@keyframes preparing-data-spin {
  to {
    transform: rotate(360deg);
  }
}

.registration {
  background: var(--surface);
  border: 1px solid var(--line);
  box-sizing: border-box;
  border-radius: var(--radius-lg);
}

.registration .tabs-component-tabs {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 0;
  border-right: 1px solid var(--line);
  z-index: 100;
  padding: 0;
  margin: 0 0 24px 1.875rem;
  height: 100vh;
}

.registration .add-doctor {
  margin-top: 8px;
}

.registration .add-doctor span {
  margin-left: 8px;
  font-size: var(--fs-xs);
  line-height: 16px;
  letter-spacing: 0.08em;
  color: var(--accent-600);
}

.registration .tabs-component-tab {
  list-style: none;
  border: 1px solid var(--line);
  border-right: none;
  padding: 9px 34px;
  overflow: hidden;
}

.registration .tabs-component-tab:first-child {
  border-right: none;
  border-bottom: none;
}

.registration .tabs-component-tab:last-child {
  border-top-right-radius: var(--radius-sm);
  border-bottom-right-radius: var(--radius-sm);
  border-right: 1px solid var(--line) !important;
  border-left: none;
}

.registration .tabs-component-tab:last-child {
  border-right: none;
}

.registration .tabs-component-tab .tabs-component-tab-a {
  font-style: normal;
  font-weight: 500;
  font-size: var(--fs-body);
  line-height: 25px;
  letter-spacing: 0.08em;
  color: var(--text);
  width: 100%;
}

.registration .tabs-component-panels {
  border-top: 1px solid var(--line);
}

.registration .patient-registration {
  border-bottom: 1px solid var(--line);
  margin-bottom: 45px;
}

.registration .patient-registration .search img {
  margin-right: 52px;
}

.registration .patient-registration .search-registration {
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
}

.registration .patient-registration .search-registration input {
  border: none;
  margin: 0;
  width: 250px;
}

.registration .patient-information {
  border-bottom: 1px solid var(--line);
}

.registration .patient-information .heading h2 {
  font-style: normal;
  font-weight: 600;
  font-size: var(--fs-h2);
  line-height: 33px;
  letter-spacing: var(--tracking-tight);
  text-transform: capitalize;
  color: var(--ink-900);
}

.registration .patient-information .heading p {
  font-weight: 600;
  font-size: var(--fs-body);
  line-height: 25px;
  letter-spacing: 0.08em;
  text-transform: capitalize;
  color: var(--text);
}

#registration .actions span {
  color: var(--muted) !important;
}

.services .invoice-select {
  margin-top: 0 !important;
}

.total-bill .total {
  flex-direction: column;
  align-items: flex-end;
}

.total-bill .total h2 {
  font-weight: 600;
  font-size: 1.1rem;
  line-height: 30px;
  letter-spacing: 0.05em;
  color: var(--ink-900);
}

.total-bill .discount .discount-amount {
  flex-direction: column;
}

.total-bill .discount .custom-input {
  width: 200px;
}

#registration .technicion .header {
  justify-content: space-between;
}

.discount .invoice-type {
  flex: unset;
  margin-top: 8px;
  align-items: baseline;
  flex-direction: row-reverse;
}

.discount .Radio p {
  font-weight: 600;
  font-size: var(--fs-body);
  line-height: 25px;
  letter-spacing: 0.08em;
  text-transform: capitalize;
  color: var(--text);
}

.discount .invoice-type label {
  font-weight: 600;
  font-size: var(--fs-body);
  line-height: 25px;
  letter-spacing: 0.05em;
  color: var(--text);
}

.add-charges button {
  padding: 10px 16px;
  background: var(--surface);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--line-strong);
  box-sizing: border-box;
  border-radius: var(--radius-sm);
  font-style: normal;
  font-weight: 500;
  font-size: var(--fs-sm);
  line-height: 16px;
  letter-spacing: 0.04em;
  color: var(--accent-600);
  transition: border-color var(--dur) var(--ease),
    background var(--dur) var(--ease);
}

.add-charges button:hover {
  border-color: var(--accent-600);
  background: var(--accent-050);
}

.add-charges button img {
  margin-right: 8px;
}

.userClass {
  pointer-events: none;
  opacity: 0.5;
}

/* Print Modal Styles */
.print-modal-content {
  padding: 0;
}

.printer-status-bar {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 12px;
  border-bottom: 1px solid var(--line);
}

.printer-status-bar.connected {
  background: var(--danger-bg);
  color: var(--success);
  background: rgba(31, 122, 82, 0.08);
}

.printer-status-bar.disconnected {
  background: rgba(154, 98, 18, 0.08);
  color: var(--warning);
}

.printer-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.printer-label {
  font-weight: 600;
  font-size: var(--fs-body);
}

.printer-name {
  font-size: var(--fs-eyebrow);
  opacity: 0.8;
}

.print-options {
  padding: 16px;
}

.options-title {
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--muted);
  margin-bottom: 12px;
}

.print-option {
  display: flex;
  align-items: center;
  padding: 14px;
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  margin-bottom: 10px;
  cursor: pointer;
  transition: border-color var(--dur) var(--ease),
    background var(--dur) var(--ease);
  background: var(--surface-2);
}

.print-option:hover {
  border-color: var(--accent-500);
  background: var(--surface);
}

.print-option.selected {
  border-color: var(--accent-600);
  background: var(--accent-050);
}

.option-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin-right: 12px;
}

.option-icon.patient {
  background: var(--accent-050);
  color: var(--accent-600);
}

.option-icon.official {
  background: rgba(31, 122, 82, 0.1);
  color: var(--success);
}

.option-text {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.option-label {
  font-weight: 600;
  font-size: var(--fs-body);
  color: var(--text);
}

.option-desc {
  font-size: var(--fs-xs);
  color: var(--muted-soft);
}

.option-check {
  font-size: 22px;
}

.print-option.selected .option-check {
  color: var(--accent-600);
}

.print-option:not(.selected) .option-check {
  color: var(--line-strong);
}

.print-modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 1px solid var(--line);
  background: var(--surface-2);
}

.a4-link {
  font-size: var(--fs-xs);
  color: var(--accent-600);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 4px;
}

.a4-link:hover {
  color: var(--accent-700);
  text-decoration: underline;
}

.footer-buttons {
  display: flex;
  gap: 8px;
}

.btn-cancel {
  padding: 8px 16px;
  border: 1px solid var(--line-strong);
  background: var(--surface);
  border-radius: var(--radius-sm);
  font-size: var(--fs-sm);
  color: var(--text);
  cursor: pointer;
  transition: background var(--dur) var(--ease);
}

.btn-cancel:hover {
  background: var(--surface-2);
}

.btn-print {
  padding: 8px 20px;
  border: none;
  background: var(--grad-accent);
  color: #fff;
  border-radius: var(--radius-sm);
  font-size: var(--fs-sm);
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: var(--shadow-sm), inset 0 1px 0 rgba(255, 255, 255, 0.14);
  transition: filter var(--dur) var(--ease);
}

.btn-print:hover:not(:disabled) {
  background: var(--grad-accent-hover);
}

.btn-print:disabled {
  background: var(--line-strong);
  color: var(--muted-soft);
  cursor: not-allowed;
  box-shadow: none;
}

.button--xs {
  padding: 4px 10px;
  font-size: var(--fs-xs);
}

/* Printer Settings UI */
.printer-settings-modal-body {
  padding: 0 0.5rem;
}

.section-title {
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--muted);
  margin-bottom: 1rem;
}

.printer-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sel-card {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: border-color var(--dur) var(--ease),
    background var(--dur) var(--ease);
}

.sel-card:hover {
  background: var(--surface-2);
  border-color: var(--line-strong);
}

.sel-card.active {
  border-color: var(--accent-600);
  background: var(--accent-050);
}

.sel-card-icon {
  width: 36px;
  height: 36px;
  background: var(--surface-2);
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  color: var(--muted);
}

.sel-card.active .sel-card-icon {
  background: var(--accent-600);
  color: #fff;
}

.sel-card-icon .mdi {
  font-size: 20px;
}

.sel-card-content {
  flex: 1;
}

.sel-card-content h6 {
  margin: 0;
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--text);
}

.sel-card-content p {
  margin: 0;
  font-size: var(--fs-xs);
  color: var(--muted-soft);
}

.sel-card-radio {
  padding-left: 10px;
}

.radio-circle {
  width: 18px;
  height: 18px;
  border: 2px solid var(--line-strong);
  border-radius: 50%;
  position: relative;
}

.sel-card.active .radio-circle {
  border-color: var(--accent-600);
}

.sel-card.active .radio-circle::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 8px;
  height: 8px;
  background: var(--accent-600);
  border-radius: 50%;
}

.printer-status-block {
  margin-top: 20px;
  padding: 16px;
  background: var(--surface-2);
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 100px;
  font-size: var(--fs-eyebrow);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: var(--tracking-eyebrow);
}

.bg-success-light {
  background: rgba(31, 122, 82, 0.1);
  color: var(--success);
}
.bg-warning-light {
  background: rgba(154, 98, 18, 0.1);
  color: var(--warning);
}

.status-detail {
  display: flex;
  align-items: center;
  gap: 12px;
}

.status-icon-box {
  width: 40px;
  height: 40px;
  background: var(--accent-050);
  color: var(--accent-600);
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-icon-box.inactive {
  background: var(--surface-2);
  color: var(--muted-soft);
}

.status-icon-box .mdi {
  font-size: 22px;
}

.status-text-box {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.device-name {
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--text);
}

.device-hint {
  font-size: var(--fs-xs);
  color: var(--muted-soft);
}

.modal-footer-actions {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.modal-footer-actions .button {
  min-width: 100px;
}
</style>
